import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import styled from 'styled-components';
import { BuyDialogBody } from './BuyDialogBody';

const BuyDialogStyle = styled(Dialog)`

`;

export const BuyDialog = ({ open, onClose, ...props }) => {
  return <BuyDialogStyle
    open={open}
    onClose={onClose}
  >
    {open && <BuyDialogBody onClose={onClose} {...props} />}
  </BuyDialogStyle>;
};


BuyDialog.propTypes = {
  open: PropTypes.bool,
  ...BuyDialogBody.propTypes,
};
